import React from "react";
import { FaBookReader, FaBriefcase, FaCogs, FaDesktop, FaHandshake, FaShippingFast, FaTools, FaTruck } from "react-icons/fa";
import { HiLibrary } from "react-icons/hi";
import { MdDesignServices, MdHomeRepairService } from "react-icons/md";
import { GrServices } from "react-icons/gr";

  const iconMapping = {
    icon1: <FaBookReader />,
    icon2: <FaBriefcase />,
    icon3: <HiLibrary />,
    icon4: <FaDesktop />,
    icon5: <MdDesignServices />,
    icon6: <MdHomeRepairService />,
    icon7: <GrServices />,
    icon8: <FaTools />,
    icon9: <FaCogs />,
    icon10: <FaHandshake/>,
    icon11: <FaShippingFast />,
    icon12: <FaTruck />,
  };

const Mission = ({ filteredData,setModal,setTitle,setDescription}) => {
  return (
    <div className="react_populars_topics react_populars_topics2 react_populars_topics_about pt---150 pb---120">
      <div className="container">
        <div className="row pt---30" >
          {filteredData.map((item, index) => {
         
            const icon = iconMapping[item.icon] || null;

            return (
              <div
                key={item.id || index} // Ensure 'key' is unique (prefer item.id)
                className="col-md-6 wow animate__fadeInUp"
                data-wow-duration="0.3s"
              >
                <div className="item__inner mvIcon" style={{width:"100%",cursor:"pointer",height:"320px"}} onClick={()=>{
                  setDescription(item.description)
                  setTitle(item.title)
                  setModal(true)}}>
                  <div className="icon-container">
                    {/* Render the icon inside the container */}
                    {icon}
                  </div>
                  <div className="react-content">
                    <h3 className="react-title">
                      <a href="courses-grid.html">{item.title}</a>
                    </h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Mission;
